import { BaseVariant } from 'src/components/ProductDetail/utils/product-detail.types';
import Bugsnag from '@bugsnag/js';

import { ProductConfigOptions } from '../ProductOptions';

/**
 * Selco will (for the short term) only support a single configurable option.
 * This means we can short-circuit a lot of logic based around resolving many options
 * down to a simple product.
 *
 * @param options
 * @param variants
 * @param search
 */
export function selectVariant(
    options: ProductConfigOptions[] | undefined,
    variants: BaseVariant[] | undefined,
    search: string,
): BaseVariant | undefined {
    /**
     * Always bail if either options or variants
     * are missing. This is mostly a helper to keep component
     * types simpler
     */
    if (!options || !variants) return undefined;

    /**
     * Try, in order:
     *
     *      1. look at url params
     *      2. try to select based on given 'rules'
     */
    return fromSearch(options, variants, search) || selectFirst(options, variants);
}

/**
 * Look at url params to see if they contain anything that can be used
 * to pre-select an option on screen
 * @param _options
 * @param variants
 * @param search
 */
function fromSearch(
    _options: ProductConfigOptions[],
    variants: BaseVariant[],
    search: string,
): BaseVariant | undefined {
    const params = new URLSearchParams(search);
    const color = params.get('color');
    if (!color) return undefined;

    return variants.find((curr) => {
        return curr.attributes.find((attr) => attr.code === 'color' && String(attr.value_index) === String(color));
    });
}

/**
 * 'selectFirst' is still to be decided upon as it may be first ordered,
 * lowest price or 'real deal' etc.
 */
function selectFirst(options: ProductConfigOptions[], variants: BaseVariant[]): BaseVariant | undefined {
    if (options.length > 0) {
        const color = options.find((option) => option.attribute_code === 'color');
        if (color) {
            const firstColorIndex = color.values[0]?.value_index;
            if (firstColorIndex) {
                const firstVariant = variants.find((curr) => {
                    return curr.attributes.some((attr) => {
                        return attr.code === 'color' && attr.value_index === firstColorIndex;
                    });
                });
                if (!firstVariant) {
                    Bugsnag.notify('Could not lookup first variant');
                    return undefined;
                }
                return firstVariant;
            }
        }
    }

    return undefined;
}

// /**
//  * Take all available options & the selected variant and transform
//  * into the correct Payload for adding configurable products to basket.
//  * @param options
//  * @param variant
//  */
// export function createConfigOptions(
//     options?: ProductConfigOptions[],
//     variant?: ProductVariant,
// ): QuoteDataProductOptionInterface | undefined {
//     if (!options || !variant) return undefined;
//
//     const output: ConfigurableProductDataConfigurableItemOptionValueInterface[] = [];
//     options.forEach((opt) => {
//         const first = opt.values.find((val) => val.value_index === variant.value_index);
//         if (first) {
//             output.push({ option_id: opt.attribute_id, option_value: variant.value_index });
//         }
//     });
//
//     return {
//         extension_attributes: {
//             configurable_item_options: output,
//         },
//     };
// }
//
// /**
//  * Take all available options & the selected variant and transform
//  * into the correct Payload for adding configurable products to basket.
//  * @param options
//  * @param variant
//  */
// export function createConfigDisplayOptions(
//     options?: ProductConfigOptions[],
//     variant?: ProductVariant,
// ): ConfigDisplay | undefined {
//     if (!options || !variant) return undefined;
//
//     const opts: ConfigDisplay[] = options.map(opt => {
//         const value_match = opt.values.find(val => val.value_index === variant.value_index);
//         if (!value_match) {
//             throw new Error('Could not access a matching value for the given variant');
//         }
//         return {
//             option_id: Number(opt.attribute_id),
//             option_value: value_match.value_index,
//             attribute_label: opt.label,
//             attribute_value: value_match.label,
//         };
//     });
//
//     return opts[0];
// }
